import { Link, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import WarningTriangle from '@swf/core/assets/icons/warning-triangle.svg';
import { useOpenVerifyAccount } from '@swf/verification/AccountVerification/useOpenVerifyAccount';

import {
  TXTCLI_Due_to_German_gambling_regulat_ELL,
  TXTCLI_Thank_youX_your_address_has_be_ELL,
  TXTCLI_Verify_ID,
  TXTCLI_You_will_not_be_able_to_make_w_ELL_1,
  TXTCLI_Your_account_will_be_closed_if_ELL
} from './ErrorResponseMessage.messages.json';
import styles from './ErrorResponseMessage.scss';

export const ErrorResponseMessage: React.FC = () => {
  const openVerifyAccount = useOpenVerifyAccount();

  return (
    <StarsInfo type="warning" className={styles.message}>
      <>
        <WarningTriangle className={styles.warningTriangleIcon} />
        <div className={styles.hasTitle}>
          <Translation tagName="p" {...TXTCLI_Thank_youX_your_address_has_be_ELL} />

          <Translation tagName="p" {...TXTCLI_Due_to_German_gambling_regulat_ELL} />
          <Translation tagName="p" {...TXTCLI_You_will_not_be_able_to_make_w_ELL_1} />
          <p>
            <Translation {...TXTCLI_Your_account_will_be_closed_if_ELL} />{' '}
          </p>

          <Link onClick={openVerifyAccount}>
            <Translation {...TXTCLI_Verify_ID} />
          </Link>
        </div>
      </>
    </StarsInfo>
  );
};

export default ErrorResponseMessage;
